const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const buildDepositMethodFormData = (payload) => {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

export const createLeadSpecificDepositMethodApi = async (leadId, payload) => {
    const token = localStorage.getItem('token');
    const url = `${API_BASE_URL}/admin/lead/leads/${leadId}/deposit-methods`;

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: buildDepositMethodFormData(payload),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось создать метод депозита лида.`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};
